/**
 * @file 小程序搜索来源日志
 * @author sunhemeng@baidu.com
*/
/* globals swan, getApp, getCurrentPages */
/* eslint-disable */

export let handleSearch = () => {
  let paths = getCurrentPages();
  if (paths.length > 1) {
    return 'other';
  }
  {
    const refer = document.referrer;
    const rf = refer.match(/(m|www)\.baidu\.com/) ? 'search' : refer.match(/\/index\/\?word=/) ? 'search' : 'other';
    return rf;
  }
};